import DOMPurify from "isomorphic-dompurify";

/* dangerouslySetInnerHTML */
export const createMarkup = (data) => {
  return { __html: DOMPurify.sanitize(data) };
};
